// 标准时间转日期格式
const utils = {
  msToDate: function (msec) {
    const datetime = new Date(msec)
    const year = datetime.getFullYear()
    const month = datetime.getMonth()
    const date = datetime.getDate()
    const hour = datetime.getHours()
    const minute = datetime.getMinutes()
    const second = datetime.getSeconds()

    const result1 =
      year +
      '-' +
      (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
      '-' +
      (date + 1 < 10 ? '0' + date : date) +
      ' ' +
      (hour + 1 < 10 ? '0' + hour : hour) +
      ':' +
      (minute + 1 < 10 ? '0' + minute : minute) +
      ':' +
      (second + 1 < 10 ? '0' + second : second)

    const result2 =
      year +
      '-' +
      (month + 1 >= 10 ? month + 1 : '0' + (month + 1)) +
      '-' +
      (date + 1 < 10 ? '0' + date : date)

    const result = {
      hasTime: result1,
      withoutTime: result2
    }

    return result
  },
  // 下载防抖缓存，用于存储每个 URL 的防抖定时器
  downloadDebounceCache: {},

  downloadFile: function (url, callback, timeout = 8000) {
    // 1. URL校验
    if (!url || typeof url !== 'string' || url.trim() === '') {
      console.error('下载链接无效:', url)
      callback?.(new Error('下载链接无效'))
      return false
    }

    // 2. 格式校验
    const urlRegex = /^(https?:\/\/)?([\da-z.-]+)(\.[a-z.]{2,6})?(:\d+)?(\/[^\s]*)?$/
    if (!urlRegex.test(url)) {
      console.error('下载链接格式错误:', url)
      callback?.(new Error('下载链接格式错误'))
      return false
    }

    // 3. 防抖
    if (this.downloadDebounceCache?.[url]) {
      callback?.(new Error('下载请求过于频繁，请稍后再试'))
      return false
    }
    if (!this.downloadDebounceCache) {
      this.downloadDebounceCache = {}
    }
    this.downloadDebounceCache[url] = true
    setTimeout(() => {
      delete this.downloadDebounceCache[url]
    }, 1000)

    // 4. 开始下载
    fetch(url, {
      method: 'GET',
      credentials: 'include',
      signal: AbortSignal.timeout(timeout)
    })
      .then(async res => {
        const responseClone = res.clone()
        try {
          const json = await res.json()
          if (json.status_code !== 200) {
            // 成功返回后端错误（不抛错，不崩溃）
            callback?.(null, { success: false, data: json })
            return
          }
        } catch {
          // 从后端响应头获取真实文件名
          let fileName = null
          // 方法1: 尝试从 content-disposition 头获取 (需要后端设置 CORS ExposeHeaders)
          const disposition = responseClone.headers.get('Content-Disposition')
          if (disposition) {
            const starMatch = disposition.match(/filename\*=utf-8''([^;]+)/i)
            if (starMatch) {
              fileName = decodeURIComponent(starMatch[1])
            } else {
              const normalMatch = disposition.match(/filename="([^"]+)"/i)
              if (normalMatch) fileName = normalMatch[1]
            }
            console.log('从 Content-Disposition 头中获取文件名::', fileName)
          }

          // 方法2: 降级方案 - 从 URL 的 fileId 参数获取文件名
          if (!fileName) {
            try {
              const urlObj = new URL(url)
              const fileId = urlObj.searchParams.get('fileId')
              if (fileId) {
                fileName = decodeURIComponent(fileId)
                console.log('从 fileId 参数获取文件名:', fileName)
              }
            } catch (e) {
              console.warn('URL 解析失败:', e)
            }
          }

          // 最终降级方案 - 使用默认文件名
          if (!fileName) {
            fileName = '下载文件'
            console.log('使用默认文件名:', fileName)
          }

          // 下载文件
          const blob = await responseClone.blob()
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = fileName // 后端真实文件名
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(blobUrl)

          callback?.(null, { success: true })
        }
      })
      .catch(err => {
        callback?.(err)
      })

    return true
  },

  debounce: function (func, wait) {
    let timeout
    return function () {
      const context = this
      const args = arguments
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, wait)
    }
  }
}

export default utils
